import { Component, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { ProfileService } from '@teem/core/services/profile.service';
import { LoaderService } from '@teem/services/loader.service';
import { SigninModalComponent } from '@teem/customer/modals/signin-modal/signin-modal.component';
import { SignupModalComponent } from '@teem/customer/modals/signup-modal/signup-modal.component';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ProfileComponent {
	customerInfo: any = {};
	isUserLogged: boolean = false;
	isSignupPop: boolean = false;
	showComponent: any = 'signin';
	routeSubscriber: any;

	constructor(
		private modalService: NgbModal,
		private route: ActivatedRoute,
		private loaderService: LoaderService,
		private profileService: ProfileService,
		private customerAuthService: CustomerAuthService,
		private sharedDataService : SharedDataService
	) { 
		this.sharedDataService.asObservable().subscribe((data) => {
			if (data && data.customerInfo) {
			  this.customerInfo = data.customerInfo
			}
		});

		this.routeSubscriber = this.route.queryParams.subscribe(params => {
			// Defaults to 0 if no query param provided.
			if (params && params['signup']) {
				this.isUserLogged = false;
				this.authToggle('signup');
				// this.openSignUpModal();
			}
		});
	}

	ngOnInit(): void {
		let customer: any = (window as any).customerInfo ? (window as any).customerInfo : null;
		if (customer && customer.api_token) {
			this.fetchCustomerInfo();
			this.customerAuthService.loggedIn$.subscribe(status => {
				this.isUserLogged = status;
				if(status){
					this.fetchCustomerInfo();
				}
			});
		} else {
			// this.openSigninModal();
		}
	}

	fetchCustomerInfo() {
		this.loaderService.startLoading();
		this.profileService.getInfo().subscribe(data => {
			this.loaderService.stopLoading();
			this.isUserLogged = true;
			this.sharedDataService.setItem('customerInfo', data);
		}, err => {
			this.loaderService.stopLoading();
			this.isUserLogged = false;
		});
	}

	authToggle(newValue: string){
		this.showComponent = newValue;
		// this.openSigninModal()
	}

	openSigninModal(): void {
		const modalRef = this.modalService.open(SigninModalComponent, {
			backdrop: 'static',
			keyboard: false
		});
	}

	openSignUpModal(): void {
		const modalRef = this.modalService.open(SignupModalComponent, {
			backdrop: 'static',
			keyboard: false
		});
	}
	

	backToStore(): void {
		// window.history.back();
		window.location.replace(document.referrer);
	}
}